export default __webpack_public_path__ + "static/media/alternatives.f57dcc59.svg";